import * as React from "react";
import * as RDialog from "@radix-ui/react-dialog";
import { X } from "lucide-react";
import { cn } from "@/lib/cn";

export const Dialog = RDialog.Root;
export const DialogTrigger = RDialog.Trigger;
export const DialogClose = RDialog.Close;

export function DialogContent({
  className,
  children,
  ...props
}: React.ComponentPropsWithoutRef<typeof RDialog.Content>) {
  return (
    <RDialog.Portal>
      <RDialog.Overlay className="fixed inset-0 z-50 bg-ink/45 backdrop-blur-md data-[state=open]:animate-fade-in" />
      <RDialog.Content
        className={cn(
          "fixed left-1/2 top-1/2 z-50 w-[88vw] max-w-md -translate-x-1/2 -translate-y-1/2",
          "max-h-[90dvh] overflow-y-auto rounded-2xl bg-surface shadow-pop border border-line-soft p-5 sm:p-6",
          // animate-slide-up менял transform (translateY) и конфликтовал с
          // нашими -translate-x-1/2/-translate-y-1/2 - диалог стартовал в
          // правом-нижнем углу и «доезжал» до центра. Используем чистый
          // fade-in: opacity без transform, центр сразу
          "data-[state=open]:animate-fade-in",
          className,
        )}
        {...props}
      >
        {children}
        <RDialog.Close className="absolute right-4 top-4 rounded-full p-1.5 text-ink-mute hover:bg-surface-2 hover:text-ink">
          <X className="h-4 w-4" />
        </RDialog.Close>
      </RDialog.Content>
    </RDialog.Portal>
  );
}

export function DialogTitle({ className, ...props }: React.ComponentPropsWithoutRef<typeof RDialog.Title>) {
  return <RDialog.Title className={cn("text-lg font-semibold text-ink", className)} {...props} />;
}

export function DialogDescription({ className, ...props }: React.ComponentPropsWithoutRef<typeof RDialog.Description>) {
  return <RDialog.Description className={cn("mt-1 text-sm text-ink-mute", className)} {...props} />;
}
